// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__OsF_9","inline":"loading_inline__famME","dots":"loading_dots__feFzI","dotFlashing":"loading_dotFlashing__Jjt5X"};